import React from 'react';
import { ZapIcon } from 'lucide-react';
export function StickyTopBar() {
  return <div className="sticky top-0 z-50 w-full bg-brand-green-dark text-white py-2 px-4 shadow-md" data-id="element-218">
      <div className="max-w-6xl mx-auto flex items-center justify-center text-center text-xs sm:text-sm md:text-base font-medium" data-id="element-219">
        <ZapIcon className="w-3 h-3 sm:w-4 sm:h-4 text-brand-amber mr-1 sm:mr-2 flex-shrink-0 animate-pulse" data-id="element-220" />
        <span className="mr-1 sm:mr-2" data-id="element-221">
          Oferta especial:{' '}
          <span className="text-brand-amber font-bold" data-id="element-222">70% de descuento</span> —
          ¡Solo por tiempo limitado!
        </span>
      </div>
    </div>;
}